import {Component, EventEmitter, inject, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ApproveModalComponent} from "./approve-modal/approve-modal.component";
import {RejectModalComponent} from "./reject-modal/reject-modal.component";
import { CommonModule } from '@angular/common';
import { RepairDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/repairs/models/repair-dto';
import Utils from "../../../../helpers/utils";
import {AdjusterDto} from "../../../../auto-generated-server-dtos/adjuster/claim/assign-to/adjuster-dto";
import { AssignToStateService } from '../assign-to/services/assign-to-state.service';

@Component({
  selector: 'app-approve-reject',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './approve-reject.component.html',
  styleUrl: './approve-reject.component.scss'
})
export class ApproveRejectComponent implements OnInit {
    @Input() claimDto!: ClaimDto;
    @Input() repairsDto!: RepairDto[];
    @Input() repairTotal!: number;
    @Input() minimalUi: boolean = false;
    @Input() customerRecordMatch: boolean = false;
    @Input() assignedAdjuster!: AdjusterDto | null;

    @Output() claimChange = new EventEmitter();
    @Output() refreshClaim = new EventEmitter<void>();

    actionDisabled: boolean = true;
    
    assignToStateService = inject(AssignToStateService)
    private adjusterId!: string;
    constructor(private ngbModal: NgbModal) {
    }

    ngOnInit() {
        this.actionDisabled = this.disableAction();
        this.assignToStateService.selectedAdjuster$.subscribe(adjusterId => {
            if (adjusterId) {
                this.adjusterId = adjusterId;
            }
        });
    }

    ngDoCheck() {
        if (this.claimDto) {
            this.actionDisabled = this.disableAction();
        }
    }

    approve() {
        const modalRef = this.ngbModal.open(ApproveModalComponent, {
            size: 'lg',
        });
        this.setApproveRejectComponentInstance(modalRef)
    }

    reject() {
        const modalRef = this.ngbModal.open(RejectModalComponent, {
            size: 'lg',
        });
        this.setApproveRejectComponentInstance(modalRef);
    }

    setApproveRejectComponentInstance(modalRef: NgbModalRef) {
        modalRef.componentInstance.claimDto = this.claimDto;
        modalRef.componentInstance.repairsDto = this.repairsDto;
        modalRef.componentInstance.repairTotal = this.repairTotal;
        modalRef.componentInstance.customerRecordMatch = this.customerRecordMatch;
        modalRef.componentInstance.refreshClaim.subscribe(() => {
            this.refreshClaim.emit();
        });
    }

    disableAction() {
        return this.claimDto.isLocked || this.claimDto.isClaimTestData || !this.assignedAdjuster || !Utils.isValidAuthorizationNumber(this.claimDto.authorizationNumber) || !this.adjusterId;
    }
}